import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './MapPlaceholder.css';

type MapPlaceholderProps = {
  isMapOpen: boolean;
  onPlaceholderClick: VoidFunction;
};

export const MapPlaceholder: FC<MapPlaceholderProps> = ({ onPlaceholderClick, isMapOpen }) => {
  return (
    <div
      className={clsx(styles['map-placeholder'], isMapOpen && styles['is-open'])}
      data-testid="map.placeholder"
      onClick={onPlaceholderClick}
    ></div>
  );
};
